export type EntryRoute = "public" | "control-lab" | "blocked-review";

function normalizedSegments(pathname: string) {
  return pathname
    .split("/")
    .map((segment) => segment.trim().toLowerCase())
    .filter(Boolean);
}

export function resolveEntryRoute(pathname: string): EntryRoute {
  const segments = normalizedSegments(pathname);
  const lastSegment = segments.at(-1);

  if (lastSegment === "control-lab") return "control-lab";
  if (segments.includes("artboard") || segments.includes("soundboard")) return "blocked-review";
  return "public";
}
